<app-header [currentURL]="history[history.length - 1]">
</app-header>
<router-outlet>
</router-outlet>
